'use strict';

// TODO: implement 'input' alternative for 'legacy'
//import 'components/input';

const ATTRIBUTE = 'data-language-switch';
const HOOK = '[' + ATTRIBUTE + ']';

window.addEventListener('DOMContentLoaded', () => {
    let select = document.querySelector(HOOK);
    if (select) {
        select.addEventListener('change', event => {
            let select = event.target;
            window.location = select.getAttribute(ATTRIBUTE) + select.options[select.selectedIndex].value;
        });
    }
});
